import { createDecorator } from 'vue-class-component'
import * as functionUtils from '@ustra/core/src/utils/function-utils'

export const Loading = () => {
  return createDecorator((options, key) => {
    const originalMethod = options.methods[key]

    // @ts-ignore
    options.methods[key] = functionUtils.wrap(originalMethod, function (next) {
      let result
      try {
        this.$ustra.ui.progress.show()
        result = next()

        if (functionUtils.isPromise(result)) {
          result.finally(() => this.$ustra.ui.progress.hide())
        }
      } finally {
        if (!functionUtils.isPromise(result)) {
          this.$ustra.ui.progress.hide()
        }
      }

      return result
    })
  })
}
